import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=b22ce890&scoped=true&"
import script from "./Publication.vue?vue&type=script&lang=js&"
export * from "./Publication.vue?vue&type=script&lang=js&"
import style0 from "./Publication.vue?vue&type=style&index=0&id=b22ce890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22ce890",
  null
  
)

export default component.exports